import { render } from "./CodePreviewer.vue?vue&type=template&id=e1d766c4&scoped=true"
import script from "./CodePreviewer.vue?vue&type=script&lang=js"
export * from "./CodePreviewer.vue?vue&type=script&lang=js"

import "./CodePreviewer.vue?vue&type=style&index=0&id=e1d766c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d766c4"]])

export default __exports__